import ReactTooltip from "react-tooltip";

const ToolTip = ({ content = '', label = '', className = '' }) => {
    return <><ReactTooltip id="tooltip" className="tooltipContent" /><span className={className} data-for="tooltip" data-tip={content}>{label}</span></>
}
export default ToolTip;